import { navigate } from 'gatsby';

export { wrapRootElement } from "./src/apollo/wrap-root-element";

// Override the Gatsby navigate function to intercept language-based redirects
if (typeof window !== 'undefined') {
  const originalNavigate = window.__navigate || navigate;
  
  const customNavigate = (to, options) => {
    // Check if this is a language-based navigation (looking for /en/ or /es/ patterns)
    const isLanguageNavigation = typeof to === 'string' && /^\/[a-z]{2}\//.test(to);
    
    // If it's a language change and we want to stay on the same page
    if (isLanguageNavigation) {
      // Extract the path without the language prefix
      const pathWithoutLang = to.replace(/^\/[a-z]{2}\//, '/');
      
      // Get the current path without any language prefix
      const currentPath = window.location.pathname.replace(/^\/[a-z]{2}\//, '/');
      
      // If we're navigating to the same page but just with a different language
      // (e.g., from /page to /es/page), prevent the URL change
      if (pathWithoutLang === currentPath || pathWithoutLang === '/' + currentPath) {
        return;
      }
    }
    
    // For all other cases, use the original navigate function
    return originalNavigate(to, options);
  };
  
  // Replace the navigate function
  window.__navigate = customNavigate;
}

export const onInitialClientRender = () => {
  if (window.location.pathname === '/') {
    navigate('/swap', { replace: true });
  }
};